import { ACTION } from './project_location_actions';
import { list_reducer } from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  isLoading: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_location_reducer.js